import { useSelector } from 'react-redux';
import { selectLang } from '../../store/ui/ui.selector';
import { Button, Title } from '../../components/shared';
import { translate } from '../../lib/lang.helper';
import { getTemplateLink } from '../../apis';

const LibraryPage = () => {
  const lang = useSelector(selectLang);

  return (
    <div className='content pb-32'>
      <Title
        className='mb-24'
        size={5}
        color='black-3'
        align='default'
        fontWeight={600}
      >
        {translate(lang, 'Form Library')}
      </Title>
      <div className='mb-24 mt-24'>
        <div className='mb-32'>
          <a href={getTemplateLink('Sample-Timesheet.xlsx')} download={true}>
            <Button type='fill' width='small' size={2} color='blue'>
              {translate(lang, '_download_sample_timesheet')}
            </Button>
          </a>
        </div>
        <div className='mb-32'>
          <a href={getTemplateLink('Seeding-Scan-Form.docx')} download={true}>
            <Button type='fill' width='small' size={2} color='blue'>
              {translate(lang, '_download_sample_ocr_seeding')}
            </Button>
          </a>
        </div>
        <div className='mb-32'>
          <a
            href={getTemplateLink('Assessment-Scan-Form.docx')}
            download={true}
          >
            <Button type='fill' width='small' size={2} color='blue'>
              {translate(lang, '_download_sample_ocr_assess')}
            </Button>
          </a>
        </div>
        <div className='mb-32'>
          <a href={getTemplateLink('Floating-Scan-Form.docx')} download={true}>
            <Button type='fill' width='small' size={2} color='blue'>
              {translate(lang, '_download_sample_ocr_floating')}
            </Button>
          </a>
        </div>
        <div className='mb-32'>
          <a href={getTemplateLink('Harvest-Scan-Form.docx')} download={true}>
            <Button type='fill' width='small' size={2} color='blue'>
              {translate(lang, '_download_sample_ocr_harvest')}
            </Button>
          </a>
        </div>
      </div>
    </div>
  );
};

export default LibraryPage;
